import React, {useState} from 'react';
import {Card, CardContent, Grid, Typography, Button } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import Card64Image from 'components/card64Image';
import { useDispatch } from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { tipoDeMedio } from 'constantes/globalsStates';
import { functions } from 'constantes';
import TablaPersonalizada from 'components/TablaPersonalizada';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { Edit } from '@mui/icons-material';
import AgregarRangoEdad from './AgregarRangoEdad';
import { patchPersonalizadoConDosMetodos } from 'store/actions/customAction';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import EditarDatosDeTelevision from './EditarDatosDeTelevision';
import EditarDatosDeRadio from './EditarDatosDeRadio';
import EditarDatosDeEscritos from './EditarDatosDeEscritos';
let idDisponibilidad = null;

const DetalleDatosDelCanal = ({datosGeneralesDelTarifario, tipoDelMedio, mostrarDetalleDelCanal}) => {
  const dispatch = useDispatch();
  const classes = styles();
  const {numeroDelCanal, canalDeTercero, medioDeComunicacion: {nombre, detallesDeMedioDeComunicacion, logo, audienciaPorEdad, tipoDeMedioDeComunicacion} } = datosGeneralesDelTarifario;

  const [tarifarioDeMediosTelevisivos] = useState('tarifarioDeMediosTelevisivos');
  const [tarifarioDeMediosRadiales] = useState('tarifarioDeMediosRadiales');
  const [tarifarioDeMediosEscritos] = useState('tarifarioDeMediosEscritos'),
  [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', abrirAlerta: false, }),
  [cargandoSolicitud, setCargandoSolicitud] = useState(false),
  [abrirModalRangoEdad, setAbrirModalRangoEdad ] = useState(false),
  [abrirModalEdicion, setAbrirModalEdicion] = useState(false),
  [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false),
  [datosDelRango, setDatosDelRango] = useState(""),
  [abrirModalEdicionRadio, setAbrirModalEdicionRadio] = useState(false),
  [abrirModalEdicionEscritos, setAbrirModalEdicionEscritos] = useState(false);

  const [encabezadoTabla] = useState([
    { title: 'Rango de edades', field: 'rangoDeEdades.rango'},
    { title: 'Acción', field: 'accion',
    render: rowData=><div style={{minWidth: '100px'}}>
        {
            (<div>
                <TooltipPersonalizado title="Rango de edad" handleFunction={() => eliminarRango(rowData)} icon="delete" fontSize={30} color="red" />
            </div>)
        }
        </div>
    },
  ]);

  const eliminarRango = ({rangoDeEdades}) => {
    idDisponibilidad = rangoDeEdades?.id;
    setAlertaDeConfirmacion(true)
    setDatosDelRango(rangoDeEdades?.rango)
  }

  const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

  const accionDeAlertaDeConfirmacion = async () => {
    setAlertaDeConfirmacion(false);
    setCargandoSolicitud(true);
    changeDataResponse('error', "")

    const controllerMedio = validarTipoDeTarifarioController();
    const data = { controller: controllerMedio, action: 'eliminar', data: {}, method: "audienciaPorEdad", methodTwo: `${datosGeneralesDelTarifario?.medioDeComunicacion?.id}/${idDisponibilidad}`, tipoMetodo: "DELETE" };
    const respuesta = await dispatch(patchPersonalizadoConDosMetodos(data));
    setCargandoSolicitud(false);
    if(respuesta?.error) {
      return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", abrirAlerta: true, });
    }
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data || "Registro eliminado correctamente", abrirAlerta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelCanal(elemento)
  }

  const validarTipoDeTarifarioController = () => {
    switch(tipoDeMedio[tipoDelMedio]) {
        case 1: return tarifarioDeMediosTelevisivos   // Television
        case 2: return tarifarioDeMediosRadiales // Radio
        case 3: return tarifarioDeMediosEscritos; // Escrito
        default: return ""
    }
  }

  const validarTipoDeTarifario = () => {
    switch(tipoDeMedio[tipoDelMedio]) {
        case 1: return ( <>
            <ElementoDelCard title={'Nombre del canal:'} label={nombre || ""}/>
            <ElementoDelCard title={'Número del canal:'} label={numeroDelCanal}/>
          </>
        )
        case 2: return ( <>
            <ElementoDelCard title={'Nombre de la radio:'} label={nombre || ""}/>
            <ElementoDelCard title={'Estación:'} label={datosGeneralesDelTarifario.estacion}/>
            <ElementoDelCard title={'Frecuencia:'} label={datosGeneralesDelTarifario?.frecuencia ? "FM" : "AM"}/>
          </>
        )
        case 3: return ( <>
            <ElementoDelCard title={'Nombre del medio:'} label={nombre || ""}/>
            <ElementoDelCard title={'Circulación:'} label={datosGeneralesDelTarifario?.tipoDeCirculacionDeMedioEscrito?.descripcion || ""}/>
            <ElementoDelCard title={'Distribución:'} label={datosGeneralesDelTarifario?.tipoDeDistribucionDeMedioEscrito?.descripcion || ""}/>
          </>
        )
        default: return <Typography>No hay información para mostrar</Typography>
    }
  }

  const validarTipoDeTarifario2 = () => {
    switch(tipoDeMedio[tipoDelMedio]) {
        case 1:
        case 2: return ( <ElementoDelCard title={'¿Se transmite en un tercero?:'} label={canalDeTercero ? "SI" : "NO" }/> )
        case 3: return ( <ElementoDelCard title={'Tipo de medio:'} label={datosGeneralesDelTarifario?.tipoDeMedioEscrito?.descripcion || ""}/> )
        default: return <Typography></Typography>
    }
  }

  const cerrarRespuesta = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const mostrarModalEdicion = () => {
    switch(tipoDeMedio[tipoDelMedio]) {
        case 1: return setAbrirModalEdicion(true);   // Television
        case 2: return setAbrirModalEdicionRadio(true) // Radio
        case 3: return setAbrirModalEdicionEscritos(true); // Escrito
        default: return ""
    }
  }
  const cerrarEdicion = () => setAbrirModalEdicion(false);
  const cerrarEdicionRadio = () => setAbrirModalEdicionRadio(false);
  const cerrarEdicionEscritos = () => setAbrirModalEdicionEscritos(false);

  const agregarRangoDeEdades = () => setAbrirModalRangoEdad(true);
  const cerrarModalRangoDeEdades = () => setAbrirModalRangoEdad(false);

  const accionRegistroGuardado = (respuesta) => {
    setAbrirModalRangoEdad(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta || "Registro eliminado correctamente", abrirAlerta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelCanal(elemento)
  }

  const accionRegistroEditado = (respuesta) => {
    setAbrirModalEdicion(false);
    setAbrirModalEdicionRadio(false);
    setAbrirModalEdicionEscritos(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data || "Registro editado correctamente", abrirAlerta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelCanal(elemento)
  }

  const cerrarModalPorError = (respuesta) => {
    cerrarModalRangoDeEdades();
    setDatosDeRespuesta('error', `${respuesta?.error}` || "Ocurrió un inconveniente. Intente de nuevo!", true)
  }

  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, abrirAlerta = false) =>  setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, abrirAlerta});

  const {tipoDeAlerta, mensajeDeAlerta, abrirAlerta} = datosDeRespuesta;

  return (
    <Card className={classes.root}>
        {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
        <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={abrirAlerta} handClose={cerrarRespuesta}/>
        <CardContent>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
              <TituloConIcono title={"Datos del medio"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid item xs={12}>
                {validarTipoDeTarifario()}
                <ElementoDelCard title={'Descripción:'} label={detallesDeMedioDeComunicacion?.descripcion || ""}/>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              {logo ? (
                  <Card64Image label={"Logo"} image={logo} title={"Logo"} src={logo} showTitle={false} showInMovil={true}/>
              ): <Typography variant="h5" component="div" align='center'>No Adjunto el logo <br/> </Typography>}
              <Grid container justifyContent={"center"} alignItems="center" mt={5}>
                <Button variant="contained" color="primary" onClick={mostrarModalEdicion} size="large">
                  <Edit />
                  Editar datos demográficos y {`${tipoDeMedioDeComunicacion?.descripcion?.toLowerCase()}`}
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TituloConIcono title={"Especificación técnicas"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <ElementoDelCard title={'Correo para recepción de materiales:'} label={detallesDeMedioDeComunicacion?.correoDeRecepcion || ""}/>
              <ElementoDelCard title={'Días de anticipación para entregar el material a pautar:'} label={detallesDeMedioDeComunicacion?.diasDeAnticipacion || ""}/>
              <ElementoDelCard title={'Especificaciones técnicas del material:'} label={detallesDeMedioDeComunicacion?.especTecnicasDelMaterial || ""}/>
              {validarTipoDeTarifario2()}
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container justify="center" alignItems="center">
                <Grid item xs={12}>
                  <TituloConIcono title={"Perfil de la audiencia"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <ElementoDelCard title={'Hombres:'} label={`${detallesDeMedioDeComunicacion?.porcentajeAudienciaHombres} %` || ""}/>
                  <ElementoDelCard title={'Mujeres:'} label={`${detallesDeMedioDeComunicacion?.porcentajeAudienciaMujeres} %` || ""}/>
                  <ElementoDelCard title={'Nivel socieconómico alto:'} label={`${detallesDeMedioDeComunicacion?.nivelSocioEconomicoAlto} %` || ""}/>
                  <ElementoDelCard title={'Nivel socieconómico medio:'} label={`${detallesDeMedioDeComunicacion?.nivelSocioEconomicoMedio} %` || ""}/>
                  <ElementoDelCard title={'Nivel socieconómico bajo:'} label={`${detallesDeMedioDeComunicacion?.nivelSocioEconomicoBajo} %` || ""}/>
                </Grid>
                <Grid item xs={12}>
                  <TituloConIcono title={"Rating y alcance"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <ElementoDelCard title={'Rating:'} label={detallesDeMedioDeComunicacion?.ratingDelMedio || ""}/>
                  <ElementoDelCard title={'Alcance en personas:'} label={detallesDeMedioDeComunicacion?.alcanceEnPersonas || ""}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <TituloConIcono title={"Rango de Edades"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              <TablaPersonalizada
                  data={functions.ordenarArreglo(audienciaPorEdad, 'id')}
                  title={""}
                  header={encabezadoTabla}
                  addRegister={agregarRangoDeEdades}
                  nameToolTipAdd={"Agregar rango"}
              />
            </Grid>
          </Grid>
          {abrirModalEdicion && (
            <EditarDatosDeTelevision
                openFullScreenDialog={abrirModalEdicion}
                handleClose={cerrarEdicion}
                title={`Formulario para editar datos demograficos y ${tipoDeMedioDeComunicacion?.descripcion?.toLowerCase()} `}
                datossDelTarifario={datosGeneralesDelTarifario}
                accionRegistroEditado={accionRegistroEditado}
            />
          )}
          {abrirModalEdicionRadio && (
            <EditarDatosDeRadio
                openFullScreenDialog={abrirModalEdicionRadio}
                handleClose={cerrarEdicionRadio}
                title={`Formulario para editar datos demograficos y ${tipoDeMedioDeComunicacion?.descripcion?.toLowerCase()} `}
                datossDelTarifario={datosGeneralesDelTarifario}
                accionRegistroEditado={accionRegistroEditado}
            />
          )}
          {abrirModalEdicionEscritos && (
            <EditarDatosDeEscritos
                openFullScreenDialog={abrirModalEdicionEscritos}
                handleClose={cerrarEdicionEscritos}
                title={`Formulario para editar datos demograficos y ${tipoDeMedioDeComunicacion?.descripcion?.toLowerCase()} `}
                datossDelTarifario={datosGeneralesDelTarifario}
                accionRegistroEditado={accionRegistroEditado}
            />
          )}
          {abrirModalRangoEdad && (
            <AgregarRangoEdad
                openFullScreenDialog={abrirModalRangoEdad}
                handleClose={cerrarModalRangoDeEdades}
                title={`Formulario para rango de edad `}
                medioDeComunicacion={{...datosGeneralesDelTarifario.medioDeComunicacion, canalDeTercero, tipoDelMedio}}
                validarTipoDeTarifario={validarTipoDeTarifarioController}
                accionRegistroGuardado={accionRegistroGuardado}
                cerrarModalPorError={cerrarModalPorError}
            />
          )}
          {alertaDeConfirmacion && (
            <ModalDeConfirmacion
                title={`¿Está seguro de eliminar el rango de ${datosDelRango || ""}?`} message={"No podrá revertir esta acción"}
                open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                actionAdd={accionDeAlertaDeConfirmacion}
            />
          )}
        </CardContent>
    </Card>
  );
}

export default DetalleDatosDelCanal;